<template>
  <overlay-container
    :id="id"
    :overlay="signal"
    :image-position-multiplier="imagePositionMultiplier"
    :document-page="documentPage"
    :file-type="fileType"
    :rotation="rotation"
    :zoom-factor="zoomFactor"
    data-testid="signal-overlay"
    :keep-visible="keepVisible"
    :show-tooltip="showTooltip"
    :is-hidden="isSignalHidden"
  >
    <template #overlay-content>
      <slot />
    </template>
  </overlay-container>
</template>

<script>
import * as signalNames from '../../../constants/signalNames';
import OverlayContainer from './OverlayContainer';
import { mapGetters } from 'vuex';
import { getInstanceId } from '@/utils/signalNames';
export default {
  components: {
    'overlay-container': OverlayContainer,
  },
  props: {
    fileType: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    documentPage: {
      type: Node,
      default: () => null,
    },
    imagePositionMultiplier: {
      type: Object,
      required: true,
    },
    rotation: {
      type: Number,
      required: true,
    },
    signal: {
      type: Object,
      required: true,
    },
    zoomFactor: {
      type: Number,
      required: true,
    },
    keepVisible: {
      type: Boolean,
      required: false,
    },
    showTooltip: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      signalNames,
      textMounted: false,
    };
  },
  computed: {
    ...mapGetters({
      getSelectedSignalsGroup: 'getSelectedSignalsGroup',
      getSelectedInstance: 'getSelectedInstance',
      getDisabledInstances: 'getDisabledInstances',
      getDisabledGroups: 'getDisabledGroups',
    }),
    isSignalHidden() {
      const instanceId = getInstanceId(
        this.signal.instance,
        this.signal.page_number,
        this.signal.signalName,
      );
      return (
        (this.getSelectedSignalsGroup &&
          this.signal.signalName !== this.getSelectedSignalsGroup?.signalKey) ||
        (!!this.getSelectedInstance &&
          this.getSelectedInstance.id !== instanceId) ||
        this.getDisabledInstances.includes(instanceId) ||
        this.getDisabledGroups.includes(this.signal.signalName)
      );
    },
  },
  watch: {
    zoomFactor() {
      this.textMounted = false;
      this.checkTextMounted();
    },
  },
  mounted() {
    this.checkTextMounted();
  },
  methods: {
    checkTextMounted() {
      if (document.querySelector('.textLayer span')) {
        this.textMounted = true;
      } else {
        setTimeout(() => {
          this.checkTextMounted();
        }, 350);
      }
    },
  },
};
</script>
